export default {
  secretsStoreType: {
    VAULT: 'vault',
    AWS: 'aws',
  },
  actions: {
    BACKUP: 'backupaction',
    BACKUP_CLUSTER: 'backupclusteraction',
    EXPORT: 'exportaction',
    IMPORT: 'importaction',
    RESTORE: 'restoreaction',
    BATCH_RESTORE: 'batchrestoreaction',
    RESTORE_CLUSTER: 'restoreclusteraction',
    RETIRE: 'retireaction',
    SYSTEM: 'system', // generic filter for retireaction, runaction, etc
    RUN: 'runaction',
    REPORT: 'reportaction',
    UPGRADE: 'upgradeaction',
    MIGRATE_FCD: 'migratefcdaction',
    VALIDATE: 'validateaction',
  },
  actionStatus: {
    ATTEMPT_FAILED: 'AttemptFailed',
    CANCELLED: 'Cancelled',
    COMPLETE: 'Complete',
    DELETING: 'Deleting',
    FAILED: 'Failed',
    PENDING: 'Pending',
    RUNNING: 'Running',
    SKIPPED: 'Skipped',
    // Deprecated
    WAITING: 'Waiting',
  },
  alertLevel: { INFO: 'info', WARNING: 'warning', ERROR: 'error' },
  localStorage: {
    K10DR: 'k10DrBannerDismissed',
    IS_MULTICLUSTER: 'isMulticluster',
    PRIMARY: 'k10.primaryClusterName',
  },
  objectStoreType: {
    AWSS3: 'S3',
    AZURE: 'AZ',
    GOOGLE: 'GCS',
    GENERIC_S3: 'GenericS3',
    FILESTORE: 'FileStore',
    VEEAM: 'VBR',
    VEEAM_VAULT_DEPRECATED: 'VeeamVault', // Deprecated; equivalent to VeeamVaultAzure
    VEEAM_VAULT_AZURE: 'VeeamVaultAzure',
    VEEAM_VAULT_AWS: 'VeeamVaultAWS',
  },
  providers: {
    AWS: 'aws',
    AZURE: 'azure',
    GOOGLE: 'google',
  },
  messages: {
    FORM_ERRORS: 'Please correct the problems above.',
    SUPPORT:
      'If you have questions or need support, please refer to <a style="text-decoration:underline; color: currentColor;" href="https://community.veeam.com/groups/kasten-k10-support-92">Kasten Community Support</a> or open a case via <a style="text-decoration:underline; color: currentColor;" href="https://my.veeam.com">https://my.veeam.com</a>.',
    KUBERNETES_NAMING:
      'Must be compatible with Kubernetes object naming (lowercase, numbers, dot, dash)',
  },
  regex: {
    BASE64: /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/,
    // Permissive bucket regex based on
    // S3:  http://docs.aws.amazon.com/AmazonS3/latest/dev/BucketRestrictions.html
    // GCS: https://cloud.google.com/storage/docs/naming
    // Permissive so these should be caught, but they're not: dot.-hyphentest dot..dottest
    BUCKET: /^[a-z0-9][a-z0-9\-._]+[a-z0-9]$/,
    AWS_KEY: /^(AKIA|ASIA|AROA|AKIAI|ASIAJ)[0-9A-Z]{16}$/,
    CAMELCASE: /^[a-z]+\S+$/,
    DNS_COMPAT: /^[a-z0-9][a-z0-9\-._]*[a-z0-9]*$/,
    EMAIL: /^.+@.+$/,
    GO_DURATION: /(\d+d)?(\d+h)?(\d+m)?(\d+s)?/,
    IAM_ROLE:
      /arn:[a-z0-9-.]{1,63}:[a-z0-9-.]{0,63}:[a-z0-9-.]{0,63}:[a-z0-9-.]{0,63}:role\/[^/].{0,1023}/, // https://docs.aws.amazon.com/a4b/latest/APIReference/API_UserData.html
    IP_OR_DOMAIN: /[a-zA-Z0-9]+\.[a-zA-Z0-9]+\.[a-zA-Z0-9]+/,
    // From https://www.regextester.com/105777
    JWT: /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/,
    KEY_COLON_VALUE: /^\S+[:=]\s*\S+$/, // PolicyForm, custom labels — accept either `key:value` or `key=value`
    K8S_LABEL_NAME_VALUE: /^[a-z0-9A-Z][a-z0-9A-Z/.\-_]{1,61}[a-z0-9A-Z]$/,
    K8S_OBJ_NAME: /^[a-z0-9]([-a-z0-9]*[a-z0-9])?(\.[a-z0-9]([-a-z0-9]*[a-z0-9])?)*$/,
    K8S_OBJ_NAME_WARNING:
      "May only contain lower case letters, numbers, '-' or '.' and must start and end with an alphanumeric character.",
    MIGRATION_STRING: /^[A-Za-z0-9+/]{50,}$/,
    // Rejects HTML tag delimiters in free-text fields (comments, display names)
    // so markup/script payloads are refused at input time (stored-XSS hardening).
    NO_HTML_TAGS: /^[^<>]*$/,
    NO_HTML_TAGS_WARNING: "Must not contain '<' or '>' characters.",
    // RFC 1123 namespace name (lowercase alphanumeric + hyphens, start/end on
    // alphanumeric) with optional leading `!` exclusion and optional trailing
    // `*` wildcard. Allows *, mysql, mysql*, !foo, !foo*; rejects MyNS, a---, a-*.
    APP_SELECTOR: /^[*]$|^[!]?[a-z0-9]([a-z0-9-]*[a-z0-9])?\*?$/,
    // RFC 1123: lowercase alphanumeric + hyphens; start and end with an
    // alphanumeric, with an optional trailing `*` wildcard.
    NAMESPACE_WILDCARD: /^[*]$|^[a-z0-9]([a-z0-9-]*[a-z0-9])?\*?$/,
    URL_PREFIX: /https?.+/,
  },
  swagger: {
    LOCATION_TYPE_OBJECT_STORE: 'ObjectStore',
    LOCATION_TYPE_FILE_STORE: 'FileStore',
    SECRET_TYPE_AWS_ACCESS_KEY: 'AwsAccessKey',
    SECRET_TYPE_GCP_SERVICE_ACCOUNT_KEY: 'GcpServiceAccountKey',
    SECRET_TYPE_AZ_STORAGE_ACCOUNT: 'AzStorageAccount',
    SECRET_TYPE_API_KEY: 'ApiKey',
    SECRET_TYPE_OPENSTACK_ACCOUNT: 'OpenStackAccount',
    SECRET_TYPE_PORTWORX_KEY: 'PortworxKey',
    SECRET_TYPE_VSPHERE_KEY: 'VSphereKey',
    SECRET_TYPE_VEEAM: 'VBRKey',
    SECRET_TYPE_VEEAM_VAULT_AZURE: 'VeeamVaultAzure',
    // Registration secret type. Legacy AWS-credentials path uses SECRET_TYPE_AWS_ACCESS_KEY.
    SECRET_TYPE_VEEAM_VAULT_AWS: 'VeeamVaultAWS',
  },
  annotations: {
    DATA_SERVICE: 'k10.kasten.io/kanisterdataservice',
    BLUEPRINT: 'kanister.kasten.io/blueprint',
    GVS: 'k10.kasten.io/forcegenericbackup',
    DR_PASSPHRASE_SOURCE: 'k10.kasten.io/drPassphraseSource',
  },
  ACCESS_DENIED: 'access_denied',
  AUTH_TYPE_OIDC: 'oidc',
  AUTH_TYPE_TOKEN: 'token',
  EXPORT_TYPE_LABEL: 'k10.kasten.io/exportType',
  FORM_ERR_MSG_DEFAULT: 'Please correct the problems above.',
  K10_DR_POLICY_NAME: 'k10-disaster-recovery-policy',
  KASTEN_APP_NS: 'k10.kasten.io/appNamespace',
  KASTEN_VM_NAMESPACE: 'k10.kasten.io/virtualMachineNamespace',
  KASTEN_VM_REF: 'k10.kasten.io/virtualMachineRef',
  MULTICLUSTER_NAMESPACE: 'kasten-io-mc',
  MULTICLUSTER_LABEL: 'dist.kio.kasten.io/distribution-id',
  MULTICLUSTER_NOT_REMOVABLE: 'dist.kio.kasten.io/manual-disconnect',
  MULTICLUSTER_DUMMY_PRIMARY_NAME: '"local cluster"',
  NS_CLUSTER_RESOURCES: 'kasten-io-cluster',
  NS_WILDCARD: '*',
  SNAPSHOT_RETENTION_MAX_RECD: 3,
  SNAPSHOT_RETENTION_MAX_ALLOWED: 32,
  FAILED_SUB_PHASES: 'FailedSubPhases',
  RESTORE_POINT_POLICY_LABEL: 'k10.kasten.io/policyName',
  RESTORE_POINT_APP_REF_KIND_VM: 'virtualmachine', // used in get Latest Restore Points requests for VM kind
  RESTORE_POINT_APP_TYPE_VM: 'virtualMachine', // used in labels for VM based Restore Points
  RESTORE_POINT_APP_TYPE_NAMESPACE: 'namespace',
  namespaceResources: {
    DATA_VOLUMES: 'volumes',
    DATA_SERVICES: 'dataservices',
    WORKLOADS: 'workloads',
    NETWORKING: 'network',
    CONFIG: 'config',
    CUSTOM_RESOURCES: 'customresources',
    CLUSTER_RESOURCES: 'clusterresources',
  },
} as const;

export const ROLE_BINDING = 'RoleBinding';
export const CLUSTER_ROLE_BINDING = 'ClusterRoleBinding';
export const ROLE = 'Role';
export const CLUSTER_ROLE = 'ClusterRole';
export const APPS_VIEW_PREF = 'appsViewPref';
export const APPS_PER_PAGE_PREF = 'appsPerPagePref';
export const HOOK_TYPES = ['preHook', 'onSuccess', 'onFailure'];
export const KUBERNETES_LABEL_MAX_CHAR_LENGTH = 63;
export const MAX_POLICY_NAME_LENGTH = 200;
export const VAULT_STATE_KEY = 'k10.vault.state';
export const VAULT_CODE_VERIFIER_KEY = 'k10.vault.codeVerifier';

// Locks DashboardCard and DashboardCardSkeleton for smooth transition.
export const MIN_DASH_CARD_HEIGHT_PX = 393.6;
